import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: false
    }
  },
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   component: () =>
  //     import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: "/resources",
    name: "Resources",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/Resource.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/account/profile",
    name: "Profile",
    component: () =>
      import(/* webpackChunkName: "profile" */ "../views/Profile.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/session/:sessionId/live",
    name: "DigitalTwin",
    component: () =>
      import(/* webpackChunkName: "session" */ "../views/DigitalTwin.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/session",
    name: "Session",
    component: () =>
      import(/* webpackChunkName: "session" */ "../views/Session.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/contact-us",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
    meta: {
      requiresAuth: false
    }
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

const isAuthenticated = () => {
  return router.app.$msal && router.app.$msal.isAuthenticated();
};

router.beforeEach((to, from, next) => {
  if (to.name === "Home" || to.name === "Contact") {
    if (isAuthenticated()) {
      next("/session");
      return;
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isAuthenticated()) {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }
});

export default router;
